import React from "react"
import HeroBanner from "./HeroBanner"

function HeroBannerWrapper({blok}) {
	return (
		<HeroBanner
			flipImageCopy={blok.flipImageCopy}
			copyMarginTop={blok.copyMarginTop}
			copyWidth={blok.copyWidth}
			whiteText={blok.whiteText}
			imageHeight={blok.imageHeight}
			imageWidth={blok.imageWidth}
			justifyImage={blok.justifyImage}
			alignButtons={blok.alignButtons}
			title={blok.title}
			subTitle={blok.subtitle}
			bgPrimary={blok.bgPrimary}
			splitScreen={blok.splitScreen}
			action={blok.action}
			media={blok.image}
			body={blok.body}
			points={blok.points}
			titleWidth={blok.titleWidth}
		/>
	)
}

export default HeroBannerWrapper
